export const SN_PARTY = 'party'
export const PARTY_NAMES_BY_LOGIN_ID_UPDATED = SN_PARTY + '/NAMES_BY_LOGIN_ID_UPDATED'
export const PARTY_NMS_BY_LGN_ID_BULK_UPDATED = SN_PARTY + '/NMS_BY_LGN_ID_BULK_UPDATED'